import { Component, OnInit, ViewChild, Input, SimpleChanges, QueryList, ChangeDetectorRef, ViewChildren } from '@angular/core';
import { CourseService } from '../services/course.service';
import { Observable } from 'rxjs';
import * as _ from 'lodash';
import { MatPaginator, MatDialog, MatMenuTrigger } from '@angular/material';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';

import { DeleteConfirmModalComponent } from '../commons/delete-confirm-modal/delete-confirm-modal.component';

import { FilterService } from '../services/filter.service';
import { JobService } from '../services/jobs/job.service';
import { TimeSheetService } from '../services/time-sheet.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router, ActivatedRoute, NavigationExtras } from '@angular/router';
import { SchedulerComponent } from '../scheduler/scheduler.component';
import { UtilityService } from './../services/utility.service'
import { UserRoleService } from '../services/user-role.service';



@Component({
  selector: 'app-jobs',
  templateUrl: './jobs.component.html',
  styleUrls: ['./jobs.component.scss']
})
export class JobsComponent implements OnInit {

  @ViewChildren('myCheckbox') private myCheckboxes: QueryList<any>;
  completionPercent;
  archivedisablebtn = true; test = [];
  searchText: string;
  jobs = [];
  courses: any = [];
  currentPage: any;
  dataSource: MatTableDataSource<any>;
  currentUser;
  loading: Boolean;
  view;
  jobsType = []
  selectedJobType = [''];
  selectedFilterActive
  selectedArchiveJob: boolean
  // MatPaginator Inputs
  length;
  pageSize = 5;
  pageSizeOptions: number[] = [25, 50, 100];

  sort: MatSort;
  paginator: MatPaginator;
  // MatPaginator Output
  pageEvent: any;

  // displayedColumns: string[] = ['title', 'client', 'location', 'instructor', 'course', 'completion', 'created', 'actions']
  displayedColumns: string[]
  jobForScheduler: any;
  displayStatus: boolean = true;
  displayClientLink: boolean;
  checkInstId: boolean = false;
  currentUserId;
  listView;
  cardView;
  afterFilter: any;
  typeOfView: string;
  viewFromState: boolean;
  noDataMsg = {
    title: "No Jobs!",
    data: "You have not yet created any jobs"
  }
  filterActive: Boolean = false;
  jobsCopy;
  totalJobs: any;
  user;
  IsChecked = false
  showArchived
  cardPageSize = 4;
  cardPageIndex = 0;
  archiveJobList = [];
  displayTitle: any
  tooltip: any
  // @ViewChild(MatPaginator,{static: false}) paginator: MatPaginator;
  @ViewChild(MatMenuTrigger, { static: false }) menuTrigger: MatMenuTrigger;
  archivedJobs: any[];
  allData: any;
  module: any;
  singleJob: any;
  jobFilter
  @ViewChild(MatSort, { static: true }) set matSort(ms: MatSort) {
    this.sort = ms;
    this.setDataSourceAttributes();
  }
  @ViewChild(MatPaginator, { static: true }) set matPaginator(mp: MatPaginator) {
    this.paginator = mp;
    this.setDataSourceAttributes();
  }
  setDataSourceAttributes() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }
  @Input('instructor') instructor;
  @Input('jobType') currentJobType;
  constructor(public change: ChangeDetectorRef, public _timeSheetService: TimeSheetService, private router: Router, public activatedRouter: ActivatedRoute, public _jobService: JobService, public _courseService: CourseService, public dialog: MatDialog, public _filter: FilterService, public _snackBar: MatSnackBar, public _utilityService: UtilityService, public _userRoleService: UserRoleService) {
    this.router.routeReuseStrategy.shouldReuseRoute = function () {
      return false;
    };
    this.activatedRouter.queryParams.subscribe(() => {
      if (this.router.getCurrentNavigation() && this.router.getCurrentNavigation().extras && this.router.getCurrentNavigation().extras.state) {
        if (this.typeOfView = this.router.getCurrentNavigation().extras.state.view) {
          this.viewFromState = true;
          console.log("IN CONSTRUCTOR")
          this.typeOfView = this.router.getCurrentNavigation().extras.state.view
        }
      }
    })
    this.dataSource = new MatTableDataSource<any>(this.jobs);
    console.log("DATA SOURCE", this.dataSource)
    this.currentUser = JSON.parse(localStorage.getItem("currentUser"));
    this.user = JSON.parse(localStorage.getItem('userRoles'))
    if (this.currentUser && this.user.isClient) {
      // this.displayedColumns = ['sr.no', 'location', 'instructor', 'course', 'completion', 'actions']
      this.displayedColumns = ['sr.no', 'location', 'instructor', 'course', 'completion', 'actions']
    }
    else if (this.currentUser && this.user.isTrainer || this.currentUser && this.user.isLearner) {
      this.displayClientLink = false
      this.currentUserId = this.currentUser._id
    }
    else this.displayClientLink = true
  }



  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }


  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();
    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  getRandomColorClass(i) {
    return this._utilityService.getCommonRandomColorClass(i)
  }

  ngOnChanges(changes: SimpleChanges): void {
    console.log("CHANGES", changes);
    if (this.instructor != undefined) {
      console.log("Instructor found");
      this.getJobsForInstructor();
      this.displayStatus = false
    }
    if (changes.currentJobType && changes.currentJobType.currentValue) {
      this.jobFilter = changes.currentJobType.currentValue
      if (this.jobFilter === 'mp') this.displayedColumns = ['title', 'client', 'location', 'instructor', 'created', 'actions']
      else this.displayedColumns = ['title', 'client', 'location', 'instructor', 'course', 'completion', 'created', 'actions']
    }
  }
  ngOnInit() {
    console.log("login user details===============", this.user);
    this.module = JSON.parse(localStorage.getItem('module'))
    if (this.module.isTrainingJob && this.module.isMpJob) {
      this.jobsType = ['trainer', 'mp']
    } else {
      this.jobsType = []
    }
    console.log("on init", this.instructor);
    this.activatedRouter.queryParams.subscribe(params => {
      if (params['view']) {
        console.log("PARAMS FOUND")
        if (params['view'] == 'isList') {
          this.listView = true
          this.typeOfView = 'isList'
        }
        else {
          this.listView = false
          this.typeOfView = 'isCard'
          console.log('Inside Else==>');
        }
      }
      else {
        if (this.viewFromState) {
          console.log("STATE FOUND")
          if (this.typeOfView == 'isCard') {
            this.listView = false
            this.router.navigate(['.'], { relativeTo: this.activatedRouter, queryParams: { view: this.typeOfView } });
          }
          else {
            this.listView = true
            this.router.navigate(['.'], { relativeTo: this.activatedRouter, queryParams: { view: this.typeOfView } });
          }
        }
        else {
          console.log("NOTHING FOUND")
          this.listView = true
        }
      }
    })
    this.loading = true;
    console.log("value of router", this.router);

    if (this.router.url.includes('/staff')) {
      console.log("Instructor found");
      this.getJobsForInstructor();
      this.view = true
    }
    else {
      console.log("Instructor not found so getting all jobs");
      this.getJobs();
      this.currentUser = JSON.parse(localStorage.currentUser);
      if (this.router.url.includes('/dashboard')) {
        this.view = true;
      }
      // else this.view = false
      console.log("VIEW VALUE IS", this.view)
      const paginatorIntl = this.paginator._intl;
      paginatorIntl.nextPageLabel = '';
      paginatorIntl.previousPageLabel = '';
    }
    console.log("JOBS COMPONENT");
  }


  checkJobs() {
    if (this.module.isTrainingJob) {
      // this.jobsType = ['trainer', 'mp']

      if (this.displayStatus) return true
      else {
        // console.log("here to check inst", this.instructor);
        if (this.instructor && this.instructor.userId.userRole.includes('trainer') || this.instructor.userId.userRole.includes('IQA')) return true
        else return false
      }
    } else {
      return false
    }
  }
  checkMedicalJobs() {
    if (this.module.isMpJob) {

      if (this.displayStatus) return true
      else {
        // console.log("here to check inst", this.instructor);
        if (this.instructor && this.instructor.userId.userRole.includes('mp')) return true
        else return false
      }
    } else {
      return false
    }
  }

  getStatus(jobs) {
    console.log('in status', jobs.length)
    let today = new Date();

    if (jobs.length != undefined) {
      for (let i = 0; i < jobs.length; i++) {
        let status;
        if (jobs[i].jobType == 'trainer') {
          for (let j = 0; j < jobs[i].singleJobDate.length; j++) {
            let lastDate = new Date(jobs[i].singleJobDate.slice(-1)[0])
            let firstDate = new Date(jobs[i].singleJobDate[0])

            if (lastDate < today) {
              status = 'Completed'
            }
            else if (firstDate < today && lastDate > today) {
              status = 'Active'
            }
            else {
              status = 'New'
            }
            Object.assign(jobs[i], { status: status })
          }
          console.log("IN GET STATUS IF")
          this.jobs = jobs;
        }
      }
    }
    else {
      console.log("here is the job Data ===>", jobs)
      // Object.assign(jobs, { status: 'New' }) 
      for (let j = 0; j < jobs.singleJobDate.length; j++) {
        console.log("in else for loop")
        if (jobs[j].jobType == 'trainer') {
          let lastDate = new Date(jobs.singleJobDate.slice(-1)[0])
          let firstDate = new Date(jobs.singleJobDate[0])
          if (lastDate < today) {
            status = 'Completed'
          }
          else if (firstDate < today && lastDate > today) {
            status = 'Active'
          }
          else {
            status = 'New'
          }
        }
      }
      this.jobs.forEach((job) => {
        if (job._id == jobs.id) {
          Object.assign(job, { status: status })
          console.log("JOB", job)
        }
      })
      //
      // this.jobs.push(jobs);
      console.log("ONLY SINGLE JOB", jobs)
    }
  }
  scheduler() {
    console.log("Scheduler Model Clicked");

    this.jobForScheduler = this.jobs;
    let dialogRefScheduler = this.dialog.open(SchedulerComponent, {
      data: this.jobForScheduler,
      // minWidth: '100vw',
      // height: '100vh'
      panelClass: 'customScheduler',
      // width: '100%',
      // margin: 'auto',
      height: '100vh',

      maxWidth: '100vw',
      maxHeight: '100vh',
      width: '70%'
    })
  }


  // UTILITY
  updateData(jobs) {
    console.log('UPDATING DATA OF ALL JOBS = ', jobs)
    this.dataSource = new MatTableDataSource(jobs);
    this.dataSource.paginator = this.paginator;
    this.dataSource.sortingDataAccessor = (item, property) => {
      console.log("item", item, "property", property);
      switch (property) {
        case 'instructor.name': return item.instructor.name;
        case 'client.name': return item.clients[0].client.name;
        case 'location.title': return item.clients[0].location.title;
        case 'created': return new Date(item.startingDate);
        case 'course.title':
          if (item.course)
            return item.course.title;
        default: return item[property];
      }
    };
    this.dataSource.sort = this.sort;
    console.log('SETTING SORT TO = ', this.dataSource.sort)
    console.log('SETTING paginator TO = ', this.dataSource.paginator)
  }

  filter(searchText) {
    this.afterFilter = null
    this.filterActive = true;
    console.log('FILTER CALLED', searchText);
    if (searchText === '') {
      this.filterActive = false;
      this.updateData(this.jobs);
      return;
    }
    let tempDataSource = this._filter.filter(searchText, this.jobs, ['title', 'client']);

    this.updateData(tempDataSource)
    if (tempDataSource.length <= 0) {
      this.afterFilter = {
        title: "No Jobs!",
        data: "Sorry, no jobs matched your search"
      }
      // this.afterFilter = "No jobs with search text found!"
    }
  }

  filterCard(searchText) {
    console.log('Filter in card view', searchText)
    this.filterActive = true;

    if (searchText === '') {
      this.jobs = this.jobsCopy;
      this.filterActive = false;
      this.afterFilter = null;
    } else {
      this.jobs = this.jobsCopy.filter(function (el) {
        return el.title.toLowerCase().includes(searchText);
      });
      if (this.jobs.length <= 0) {
        this.afterFilter = {
          title: "No Jobs!",
          data: "Sorry, no jobs matched your search"
        }
      }
    }
  }

  handlePage(e: any) {
    console.log('Hnadle page', e)
    this.cardPageIndex = e.pageIndex;
    this.cardPageSize = e.pageSize;
    this.paginate();
  }

  paginate() {
    // console.log('Paginate calling', this.cardPageIndex, this.cardPageSize, this.jobsCopy);
    const end = (this.cardPageIndex + 1) * this.cardPageSize;
    const start = this.cardPageIndex * this.cardPageSize;
    console.log('Start:', start, 'End:', end);
    let data = this.jobsCopy.slice(start, end);
    this.jobs = data;
    this.change.detectChanges();
    console.log('Paginate calling', this.cardPageIndex, this.cardPageSize, this.jobsCopy, this.jobs);
    console.log('jobs=====>', data);
  }


  // MODALS
  addJobModal() {
    console.log("hello here is the instructor data ===>", this.instructor)
    this.router.navigateByUrl('/add-job', { state: { view: this.typeOfView, instructor: this.instructor } });
    // let addedJob = this.openDialog(AddJobModalComponent, { width: '1000px', height: '967px' }).subscribe((job) => {
    //   if (job == undefined) return;
    //   console.log('Subscribe Listend Job added = ', job);
    //   this.jobs.push(job);
    //   this.updateData(this.jobs);
    //   this.getStatus(job);
    //   this.getJobs();
    //   this.openSnackBar("Job added successfully!", "Ok");
    // }, err => {
    //   return this.openSnackBar("Job could not be added!", "Ok");
    // });
  }
  addMPJob() {
    this.router.navigateByUrl('/job/addmpjob', { state: { view: this.typeOfView, instructor: this.instructor } });
  }


  editJobModal(i, data) {

    console.log('data while edit', data);
    let currentTabData
    if (data.jobType == 'trainer') {
      // http://localhost:4200/jobs/5f6b2137bc5f7c182d9a1715?courseType=Level2&currentTab=4
      // http://localhost:4200/jobs/5ef1cee3943959723eebc96a?currentTab=4
      if (data && data.course && data.course.type == 'Level2') {
        if (data.course && data.course.hasExam) {
          currentTabData = 6
        } else {
          currentTabData = 5
        }
        this.router.navigate(['/job/view/' + data._id], { queryParams: { courseType: "Level2", currentTab: currentTabData } });
      } else {
        if (data.course && data.course.hasExam) {
          currentTabData = 5
        } else {
          currentTabData = 4
        }
        this.router.navigate(['/job/view/' + data._id], { queryParams: { currentTab: currentTabData } });
      }
    }
    else {
      console.log("call this else part or not");
      this.router.navigate(['/mpjob/' + data._id], { queryParams: { currentTab: 2 } });
    }

    // this.openDialog(EditJobModalComponent, data).subscribe((data) => {
    //   console.log("DIALOG CLOSED", data)
    //   // Handle Error
    //   if (!data) return;
    //   if (data.result == "err") return this.openSnackBar("Job could not be edited!", "Ok");

    //   // EDIT HANDLE
    //   if (data.action == 'edit') {
    //     console.log("HANDLING EDIT SUCCESS", data);
    //     data = data;
    //     let index = this.jobs.findIndex(function (i) {
    //       console.log("GETTING INDEX", data)
    //       return i._id === data.data._id;
    //     })
    //     this.ngOnInit();
    //     this.jobs[Index] = data.data;
    //     this.handleSnackBar({ msg: "Job edited successfully!", button: "Ok" });
    //   }
    //   // DELETE HANDLE
    //   else if (data.action == 'delete') {
    //     console.log("Deleted ", data);
    //     this.jobs.splice(this.jobs.findIndex(function (i) {
    //       return i._id === data.data._id;
    //     }), 1);
    //     this.handleSnackBar({ msg: "Job deleted successfully!", button: "Ok" });
    //   }
    //   this.updateData(this.jobs);

    // });
  }

  handleSnackBar(data) {
    this.openSnackBar(data.msg, data.button);
  }

  openDialog(someComponent, data = {}): Observable<any> {
    console.log('OPENDIALOG', 'DATA = ', data)
    const dialogRef = this.dialog.open(someComponent, { data, width: '1000px', height: '967px' });

    return dialogRef.afterClosed();
  }
  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 2000,
    });
  }

  getJobs() {
    this._jobService.getJobs().subscribe((data) => {
      console.log('datadatadata ===>', data, this.jobFilter)
      if (data && data.finalJobArray) {

        this.jobs = data.finalJobArray.filter((x) => x.jobType === this.jobFilter);
        this.allData = data;
        this.totalJobs = this.jobs.length;
        this.jobsCopy = this.jobs;
        this.archivedJobs = data.archivedJobs.filter((x) => x.jobType === this.jobFilter);
        // this.getStatus(data.finalJobArray);
      } else {
        this.jobs = data.filter((x) => x.jobType === this.jobFilter);;
        this.allData = data.filter((x) => x.jobType === this.jobFilter);;
        this.totalJobs = this.jobs.length;
        this.jobsCopy = this.jobs;
        // this.getStatus(data);
        this.archivedJobs = data.filter((x) => x.jobType === this.jobFilter);;
      }
      if (this.typeOfView == 'isCard') {
        this.paginate();
      }
      this.loading = false;
      console.log('Jobs Received : ', this.jobs);
      this.updateData(this.jobs);
      this.completionOfJob()
    })
  }

  getJobsForInstructor() {
    if (this.instructor && this.instructor._id) {
      console.log("Jobs by instructor id", this.instructor._id);
      this._jobService.getJobByInstructorId(this.instructor._id).subscribe((data) => {
        this.jobs = data.finalJobArray;
        this.allData = data;
        this.archivedJobs = data.archivedJobs;
        this.sendJobsToEditInstructorModal()
        this.jobsCopy = this.jobs;
        this.loading = false;
        console.log('Jobs Received : ', this.jobs);
        this.updateData(this.jobs);
        this.getStatus(data.finalJobArray);
        this.completionOfJob()
      })
    } else {
      return;
    }
  }
  sendJobsToEditInstructorModal() {
    console.log("this function is call or not");

    this._jobService.sendJobToEditInstructor(this.jobs);
  }

  /**
   * 
   * archive job function 
   * 
   */
  archivejob(event, jobdata) {
    console.log("archive job selected index is:======================>", jobdata);
    console.log("selected job archive id ==================>", event.checked);
    console.log("event selected value", event)

    let job = {
      jobId: jobdata._id,
      onModel: ''
    }
    //  check job type and set model 

    if (jobdata.jobType == "trainer") {
      job.onModel = "job"
    }
    if (jobdata.jobType == "mp") {
      job.onModel = "mpjob"
    }

    // arrive job push on 
    if (event.checked == true) {

      this.archiveJobList.push(job);
      // console.log("archive length",this.archiveJobList); 
    }
    else {
      this.archiveJobList = this.archiveJobList.filter(function (obj) {
        return obj.jobId !== job.jobId;
      });

    }
    console.log("main btn value", this.showArchived);

    if (this.showArchived == false || this.showArchived == undefined) {
      this.displayTitle = 'Action'
      this.tooltip = 'Archive Jobs'
    } else {
      this.displayTitle = 'Action'
      this.tooltip = 'Unarchive Jobs'
    }
    // archive button display control 
    console.log("find unchecked object in array", this.archiveJobList);

    // console.log
  }

  /**
   **************************************** 
   * multi archive job updated functionality
   */
  jobarchiveupdate() {
    this.openDialog(DeleteConfirmModalComponent, this.tooltip).subscribe(confirm => {

      console.log("conform====>", confirm)
      if (confirm == undefined) {

        let myCheckboxes = this.myCheckboxes.toArray();
        console.log("mycheckboxeslist==========>", myCheckboxes)

        let len = myCheckboxes.length;
        for (let i = 0; i < len; i++) {
          myCheckboxes[i].checked = false;
          console.log("my checked value=======>", myCheckboxes[i].checked)
        }
        this.archiveJobList = []
        return confirm
      }
      if (confirm.confirm == "yes") {

        // ****************archive job ********
        //********************************************** */ 
        if (confirm.selectRadio == "Archive") {

          console.log("archive job update with button click & value", this.showArchived);
          // this.loading = true;
          let obj = {
            isArchived: true,
            jobs: this.archiveJobList
          }


          if (this.showArchived == true) {
            obj.isArchived = false
          }
          if (this.showArchived == false || this.showArchived == undefined) {
            obj.isArchived = true
          }
          console.log("arhicve page store obj value ===========>", obj)
          let msg = 'Jobs Archived Successfully!'
          this.apiForArchiveUpdate(obj, msg)
        }
        if (confirm.selectRadio == "Unarchive") {
          let obj = {
            isArchived: false,
            jobs: this.archiveJobList
          }
          if (this.showArchived == true) {
            obj.isArchived = false
          }
          if (this.showArchived == false || this.showArchived == undefined) {
            obj.isArchived = true
          }
          console.log("arhicve page store obj value ===========>", obj)
          let msg = 'Jobs Unarchived Successfully!'
          this.apiForArchiveUpdate(obj, msg)
        }

        // multi job delete services 
        // ***********************************

        if (confirm.confirm == "yes" && confirm.selectRadio == "Delete") {
          console.log("delete if run ...........")
          let obj = {
            isDelete: true,
            jobs: this.archiveJobList
          }
          this._jobService.deleteJobs(JSON.stringify(obj)).subscribe(
            () => {

              this.loading = false;
              this.handleSnackBar({ msg: "Jobs Delete Successfully!", button: "Ok" });
              this.getJobs();
            },
            (err) => {
              console.log("some isssue reason fail multi job update", err)
              this.handleSnackBar({ msg: "Multi-job Delete Failed!", button: "Ok" });
            })
        }
      }

      else {

        let myCheckboxes = this.myCheckboxes.toArray();
        console.log("mycheckboxeslist==========>", myCheckboxes)

        let len = myCheckboxes.length;
        for (let i = 0; i < len; i++) {
          myCheckboxes[i].checked = false;
          console.log("my checked value=======>", myCheckboxes[i].checked)
        }
        this.archiveJobList = []
      }

    })


  }

  apiForArchiveUpdate(obj, msg) {
    this._jobService.archiveMultipleJobUpdate(obj).subscribe(
      (data) => {
        console.log('datadatadata***', data)
        this.archiveJobList = [];
        this.showArchived = false;
        this.selectedJobType = []
        if (data && data.finalJobArray) {

          this.jobs = data.finalJobArray.filter((x) => x.jobType === this.jobFilter);
          this.allData = data;
          this.totalJobs = this.jobs.length;
          this.jobsCopy = this.jobs;
          this.archivedJobs = data.archivedJobs.filter((x) => x.jobType === this.jobFilter);

          // this.getStatus(data.finalJobArray);
        } else {
          this.jobs = data;
          this.allData = data;
          this.totalJobs = this.jobs.length;
          this.jobsCopy = this.jobs;
          // this.getStatus(data);
          this.archivedJobs = data;
        }
        if (this.typeOfView == 'isCard') {
          this.paginate();
        }
        this.loading = false;
        this.handleSnackBar({ msg: msg, button: "Ok" });
        console.log('Jobs Received : ', this.jobs);
        this.updateData(this.jobs);
        this.completionOfJob()
      },
      (err) => {
        console.log("some isssue reason fail multi job update", err)
        this.handleSnackBar({ msg: "Job Update Failed!", button: "Ok" });
      })
  }



  completionOfJob() {
    let oneJob;
    console.log('this.jobs', this.jobs)
    this._timeSheetService.getSystemDate().subscribe((date) => {
      console.log('date response========>', date.sytemTime);
      this.jobs.forEach((job) => {
        oneJob = job;
        if (oneJob.jobType == 'trainer') {
          let start;
          let end;
          if (oneJob.scheduleDates && oneJob.scheduleDates == true) {
            console.log("oneJob.scheduleDates in if", oneJob.scheduleDates)
            start = new Date(oneJob.startingDate).getTime()
            end = new Date(oneJob.endingDate).getTime()
          } else {
            start = new Date(oneJob.singleJobDate[0].date).getTime()
            end = new Date(oneJob.singleJobDate[oneJob.singleJobDate.length - 1].date).getTime()
          }

          let today = date.sytemTime
          let totalDays = (end - start) / (1000 * 3600 * 24)
          let daysPassed = (today - start) / (1000 * 3600 * 24)

          this.completionPercent = Math.round((daysPassed / totalDays) * 100);
          // console.log("this.completionPercent---->", this.completionPercent);
          if (this.completionPercent > 100) {
            // console.log(job.title, "complete==", this.completionPercent);
            this.completionPercent = 100;
          }
          else if (this.completionPercent < 0) {
            // console.log(job.title, "has NOT begun==", this.completionPercent);
            this.completionPercent = 0;
          }
          // else { console.log(job.title, "in progress==", this.completionPercent); }
          job["completion"] = this.completionPercent;
        }
      })
      this.updateData(this.jobs)
      console.log("IN COMPLITION FUNCTION", this.jobs);
      if (this.typeOfView == 'isCard') {
        this.paginate();
      }
    })
  }
  jobDeletedCardView(event) {
    console.log("job with index", event.index, "is deleted")
    this.jobs.splice(event.index, 1)
  }
  viewChanged(type) {
    console.log('View Changes===>', type);
    this.typeOfView = type;
    if (type == 'isList') {
      this.listView = true;
    }
    else {
      this.listView = false;
    }
    this.router.navigate(['.'], { relativeTo: this.activatedRouter, queryParams: { view: type } });
  }
  goToSingleJob(job) {
    // [routerLink] = '[job.jobType == "trainer" ? "/jobs/"+job._id : "/mpjob/"+job._id]'[state] = "{job: job}"
    console.log("JOB", job);

    if (job.jobType == 'trainer') {
      console.log("IF JOBTYPE TRAINER");
      let param = {
        courseType: job.course.type
      }
      console.log("param =====================", param)
      this.router.navigate(['/job/view/' + job._id], { queryParams: param })
    }
    else {
      this.router.navigateByUrl('job/mpjob/' + job._id, { state: { job: job } })
    }

  }

  async goToCourse(job) {
    console.log("job ??  ", job);
    // let navigationExtras: NavigationExtras = {
    //   state: {
    //     job: job
    //   }
    // };
    this.singleJob = job
    let userRole = await this.getUserRole()
    console.log("userRole !!!!  ", userRole);
    let param = {
      userRole: userRole
    }
    this.router.navigate(['/materials/' + job.course.templateId], { queryParams: param })
    // this.router.navigateByUrl('/materials/' + job.course.templateId + "userRole=" + userRole);

  }

  getUserRole() {
    let getRole = this._userRoleService.getUserRole(this.singleJob.instructors, 'job');
    console.log("getRole ?? ", getRole);
    if (getRole.isAdmin) return 0
    else if (getRole.isTrainer) return 1
    else if (getRole.isIQA) return 2
    else if (getRole.isLearner) return 3
    else if (getRole.isClient) return 4
  }

  selectedJobChanged() {
    // this.selectedFilterActive = true
    (this.selectedFilterActive) ? this.selectedFilterActive = false : this.selectedFilterActive = true

    this.jobs = this.allData.finalJobArray

    // console.log('Job Type Changed', this.jobs);
    let finalList: any = []
    finalList = this.selectedJobType
    let uniqArray
    if (finalList && finalList.length) {


      if (this.selectedArchiveJob) {
        console.log("what is the final list", finalList);
        let archiveFinalData = this.allData.archivedJobs.filter(job => this.selectedJobType.includes(job.jobType))
        this.jobs = archiveFinalData
        // this.jobsCopy = archiveFinalData

        this.getStatus(archiveFinalData);
        this.updateData(archiveFinalData)
        this.completionOfJob()

        this.noDataMsg = {
          title: "No Jobs!",
          data: "You have not yet archived any jobs"
        }
      }
      else {
        let otherList

        let array = []
        var count;
        _.forEach(finalList, track => {
          count = (_.filter(this.jobs, (o: any) => {
            if (o.jobType == track)
              array.push(o)
            // return o
          }));
        });


        console.log("sorted list data", array);
        if (finalList.includes('All')) {
          otherList = this.jobs
        }
        console.log("other list data", otherList);

        if (otherList == undefined) {
          uniqArray = array
        } else {
          uniqArray = otherList
        }
        console.log("what is the uniq array", uniqArray);
        // if (uniqArray && uniqArray.length) {
        this.jobs = uniqArray
        this.updateData(this.jobs)
      }
      // }
    } else {

      if (this.selectedArchiveJob) {
        this.jobs = this.allData.archivedJobs
        this.updateData(this.jobs)
      }
      else {

        this.jobs = this.allData.finalJobArray
        this.updateData(this.jobs)
      }
    }



    // if (this.selectedJobType == 'All') {
    //   this.updateData(this.jobs)
    // }
    // else if (this.selectedJobType == 'Trainer') {
    //   let sortedList = this.jobs.filter(
    //     a => (a.jobType == 'trainer'))
    //   this.jobs = sortedList
    //   this.updateData(this.jobs)
    // }
    // else {
    //   let sortedList = this.jobs.filter(
    //     a => (a.jobType == 'mp'))
    //   this.jobs = sortedList
    //   this.updateData(this.jobs)
    // }
  }
  displayJob(job) {
    if (job == 'trainer') {
      return 'Trainer'
    }
    if (job == 'mp') {
      return 'Medical Practitioner'
    } else {
      return job
    }
  }

  archiveChange(event) {
    this.jobs = []
    this.jobsCopy = []
    this.archiveJobList = []
    console.log('this.selectedFilterActive', event, this.selectedFilterActive, this.selectedJobType)
    if (event.checked == true) {

      this.selectedArchiveJob = true
      if (this.selectedFilterActive) {
        let archiveFinalData = this.allData.archivedJobs.filter(job => this.selectedJobType.includes(job.jobType))
        this.jobs = archiveFinalData
        this.jobsCopy = archiveFinalData

        // this.getStatus(archiveFinalData);
        this.updateData(archiveFinalData)
        this.completionOfJob()

        this.noDataMsg = {
          title: "No Jobs!",
          data: "You have not yet archived any jobs"
        }

      }
      else {
        console.log("CHECK THIS ELSE PART")
        this.jobs = this.allData.archivedJobs.filter((x) => x.jobType === this.jobFilter)
        this.jobsCopy = this.allData.archivedJobs.filter((x) => x.jobType === this.jobFilter)

        // this.getStatus(this.allData.archivedJobs);
        this.updateData(this.allData.archivedJobs)
        this.completionOfJob()
        this.noDataMsg = {
          title: "No Jobs!",
          data: "You have not yet archived any jobs"
        }
      }

    } else {

      this.selectedArchiveJob = false

      if (this.selectedFilterActive) {
        let otherList
        let array = []
        let archiveFinalData = this.allData.finalJobArray.filter(job => this.selectedJobType.includes(job.jobType))
        this.jobs = archiveFinalData
        this.jobsCopy = archiveFinalData

        // this.getStatus(archiveFinalData);
        this.updateData(archiveFinalData)
        this.completionOfJob()
        console.log("Hello Here is the updated jobs Array ", array)
      }
      else {
        this.jobs = this.allData.finalJobArray.filter((x) => x.jobType === this.jobFilter)
        this.jobsCopy = this.allData.finalJobArray.filter((x) => x.jobType === this.jobFilter)
        this.updateData(this.jobs)
      }

    }

  }

  getArchivedJobs() {
    // get archived jobs from server.
  }

}
